import CONSTANTS from '@/constants'
import moment from "moment";
import { setPushToken, removeSession } from './auth'
import {
    getMessaging,
    getToken,
} from "firebase/messaging";
const Helper = {
    methods: {
        getGender(value) {
            if (value === null) return null
            let gender = GENDER.filter(item => {
                return item.value === parseInt(value)
            })
            if (gender[0]) {
                return gender[0].label
            }
            return null
        },
        getCallStatus(value) {
            if (value === null) return null
            let status = CALL_STATUS.filter(item => {
                return item.value === parseInt(value)
            })
            if (status[0]) {
                return status[0].label
            }
            return null
        },
        getYesNoDescribed(value) {
            if (value === null) return null
            let hobby = CALL_STATUS.filter(item => {
                return item.value === parseInt(value)
            })
            if (hobby[0]) {
                return hobby[0].label
            }
            return CONSTANTS.NOT_VALUE
        },
        formatDateTime(datetime) {
            if (!datetime) {
                return null;
            }
            var date = new Date(datetime);
            if (date == "Invalid Date") date = new Date(datetime.replace(" ", "T"))

            return moment(date).format("YYYY-MM-DD");
        },
        formatDateTime2(datetime) {
            if (!datetime) {
                return null;
            }
            let date = new Date(datetime);
            return moment(date).format("YYYY/MM/DD");
        },
        formatDateTime3(datetime) {
            if (!datetime) {
                return null;
            }
            let date = new Date(parseInt(datetime));
            return moment(date).format("MM/DD HH:mm");
        },
        getCurrentDate() {
            let date = new Date();
            return moment(date).format("YYYY/MM/DD");
        },
        getImageUrl(url) {
            if (!url) return null
            if (process.env.NODE_EN == 'production') {
                return url;
            } else {
                return url.replace('http://59.106.212.134:8073', 'https://greedgreed.widosoft.com/images');
                // return url.replace('http://59.106.218.175:8083', 'https://' + CONSTANTS.DOMAIN_NAME + '/images');
            }
        },
        getTokenFirebase() {
            let messaging = getMessaging()
            getToken(messaging, { vapidKey: process.env.PUBLIC_KEY_FIREBASE }).then((currentToken) => {
                if (currentToken) {
                    setPushToken(currentToken)
                        // Send the token to your server and update the UI if necessary
                        // ...
                } else {
                    // Show permission request UI
                    console.log('No registration token available. Request permission to generate one.');
                    // ...
                }
            }).catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
                // ...
            });
        },
        checkBirthdayMonth(month, year) {
            if (!month || !year) return false
            if (parseInt((new Date).getFullYear()) - 18 > parseInt(year)) {
                return true
            }
            if (parseInt((new Date).getFullYear()) - 18 === parseInt(year)) {
                if (parseInt((new Date).getMonth()) + 1 >= parseInt(month)) {

                    return true
                }
                // if (parseInt((new Date).getMonth()) < mounth) {
                //     return false
                // }
            }
            return false
        },
        checkBirthdayDate(date, month, year) {
            if (!date || !month || !year) return false
            if (parseInt((new Date).getFullYear()) - 18 > year) {
                return true
            }
            if (parseInt((new Date).getFullYear()) - 18 == year) {
                if (parseInt((new Date).getMonth()) + 1 > month) {
                    return true
                }
                if (parseInt((new Date).getMonth()) + 1 == month) {
                    if (parseInt((new Date).getDate()) > date) {
                        return true
                    }
                }
            }
            return false
        },
        downscaleImage(file) {
            return new Promise(async(resolve) => {
                if (!file) return;

                const reader = new FileReader();
                this.fileTemp = null;
                reader.readAsDataURL(file);
                let fileName = file.name.split(".")[0];
                reader.onload = function(event) {
                    const imgElement = document.createElement("img");
                    imgElement.src = event.target.result;
                    // document.querySelector("#input").src = event.target.result;

                    imgElement.onload = function(e) {
                        let MAX_WIDTH = e.target.width;
                        if (MAX_WIDTH > 600) {
                            MAX_WIDTH = 600;
                        }

                        const canvas = document.createElement("canvas");
                        const scaleSize = MAX_WIDTH / e.target.width;
                        canvas.width = MAX_WIDTH;
                        canvas.height = e.target.height * scaleSize;

                        const ctx = canvas.getContext("2d");

                        ctx.drawImage(e.target, 0, 0, canvas.width, canvas.height);
                        canvas.toBlob(
                            function(blob) {
                                // console.info(blob.size);
                                var f2 = new File([blob], fileName + '.' + file.type.split('/')[1], {
                                    type: file.type,
                                });
                                //   console.log("f2: ", f2);
                                // this.fileTemp = f2
                                resolve(f2);
                            },
                            file.type,
                            0.5
                        );
                    };
                };
            });
        },
        getDataWithDate(data) {
            let year = '';
            let year_temp = '';
            let month = '';
            let month_temp = '';
            let date = '';
            let date_temp = '';
            let footprints = [];
            let array_temp = [];
            data.forEach(element => {
                year = new Date(element['send_date_time']).getFullYear();
                month = new Date(element['send_date_time']).getMonth() + 1;
                date = new Date(element['send_date_time']).getDate();
                array_temp.push(element);
                if (year != year_temp || month != month_temp || date != date_temp) {
                    if (year_temp != '') {
                        footprints[year_temp + '/' + month_temp + '/' + date_temp] = array_temp;
                        array_temp = [];
                    }
                }

                year_temp = year;
                month_temp = month;
                date_temp = date;


            });

            return footprints;
        },
        replaceDomain(url) {
            if (!url) return null
            if (process.env.NODE_EN == 'production') {
                return url;
            } else {
                return url.replace('http://27.133.128.203:8082', 'https://greedgreed.widosoft.com');
                // return url.replace('http://59.106.218.175:8083', 'https://' + CONSTANTS.DOMAIN_NAME);
            }
        },

        // Remove registerd question session
        remRegistQuestionSession() {
            removeSession(CONSTANTS.COOKIE_SESSION_JOB)
            removeSession(CONSTANTS.COOKIE_SESSION_HEIGHT)
            removeSession(CONSTANTS.COOKIE_SESSION_STYLE)
            removeSession(CONSTANTS.COOKIE_SESSION_INCOME)
            removeSession(CONSTANTS.COOKIE_SESSION_HOLIDAYS)
            removeSession(CONSTANTS.COOKIE_SESSION_MTG_CON)
            removeSession(CONSTANTS.COOKIE_SESSION_PURPOSE)
            removeSession(CONSTANTS.COOKIE_SESSION_MOOD_STATUS)
            removeSession(CONSTANTS.COOKIE_SESSION_PR)
        },
    }
}

export const GENDER = [{
        label: "男性",
        value: CONSTANTS.MALE
    },
    {
        label: "女性",
        value: CONSTANTS.FEMALE
    }
]
export const CALL_STATUS = [{
        label: "OK",
        value: CONSTANTS.IS_CALL
    },
    {
        label: "NO",
        value: CONSTANTS.NOT_CALL
    }
]

export const DESCRIBED = [{

        label: CONSTANTS.DESCRIBED,
        value: 1
    },
    {
        label: CONSTANTS.NO_DESCRIBED,
        value: 0
    }
]
export default Helper